import PreauthorizeFormCard from './preauthorize-form-card';

export default PreauthorizeFormCard;
